import { TrackedWalletTableTradeCell } from './tracked-wallet-table-trade-cell'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type TrackedWalletTableSoldCellProps = {
  sellVolumeInUsd: BigNumber
  sellVolumeCurrency: BigNumber
  sells: number
} & ClassNameProps

export const TrackedWalletTableSoldCell: React.FC<
  TrackedWalletTableSoldCellProps
> = (props) => {
  return (
    <TrackedWalletTableTradeCell
      color={'red'}
      volumeInUsd={props.sellVolumeInUsd}
      volumeCurrency={props.sellVolumeCurrency}
      number={props.sells}
    />
  )
}
